import React from "react";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import MailIcon from "@mui/icons-material/Mail";
import { Link } from "react-router-dom";

//-----------------------------------------------------------
const githubUrl = "https://github.com/mananc12";
const linkedinUrl = "https://www.linkedin.com/in/manan-rajput-chauhan/";
const instagramUrl = "https://www.instagram.com/manan_rajput_chauhan/";

const ExternalLink = ({ url, children }) => {
  const handleClick = () => {
    window.open(url, "_blank");
  };

  return (
    <div onClick={handleClick} style={{ cursor: "pointer" }}>
      {children}
    </div>
  );
};

const EmailLink = ({ email }) => {
  const handleClick = () => {
    window.location.href = `mailto:${email}`;
  };

  return (
    <div onClick={handleClick} style={{ cursor: "pointer" }}>
      {email}
    </div>
  );
};

const scrollToSection = (sectionId) => {
  const section = document.getElementById(sectionId);
  section.scrollIntoView({ behavior: "smooth" });
};

const Footer = () => {
  return (
    <div className="Footer">
      <div className="big-container">
        <div className="container">
          <div className="footer-links">
            <Link className="link" onClick={() => scrollToSection("home")}>
              <p>Home</p>
            </Link>
            <Link className="link" onClick={() => scrollToSection("second")}>
              <p>About</p>
            </Link>
            <Link className="link" onClick={() => scrollToSection("contact")}>
              <p> Contact</p>
            </Link>
          </div>
          <div className="footer-icons">
            <div className="url-link">
              <ExternalLink url={githubUrl}>
                <GitHubIcon className="git icons" />
              </ExternalLink>
              <ExternalLink url={githubUrl}>
                <p>{githubUrl}</p>
              </ExternalLink>
            </div>
            <div className="url-link">
              <ExternalLink url={linkedinUrl}>
                <LinkedInIcon className="linkdin icons" />
              </ExternalLink>
              <ExternalLink url={linkedinUrl}>
                <p>{linkedinUrl}</p>
              </ExternalLink>
            </div>
            <div className="url-link">
              <ExternalLink url={instagramUrl}>
                <InstagramIcon className="insta icons" />
              </ExternalLink>
              <ExternalLink url={instagramUrl}>
                <p>{instagramUrl}</p>
              </ExternalLink>
            </div>
          </div>
        </div>
        <p className="email">
          <MailIcon className="email-icon icons" />
          <EmailLink email="mananc12@gmail.com" />
        </p>
        <p className="footer-copyright">
          © 2023 Manan's Portfolio. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default Footer;
